import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/react';
import Button from '@atlaskit/button/standard-button';
import Tooltip from '@atlaskit/tooltip';
import EmojiAddIcon from '@atlaskit/icon/glyph/emoji-add';
import * as styles from './styles';

/**
 * Test id for the tooltip
 */
export var RENDER_TOOLTIP_TRIGGER_TESTID = 'render-tooltip-trigger';
export var RENDER_TRIGGER_BUTTON_TESTID = 'render-trigger-button';
/**
 * Render an emoji button to open the reactions select picker
 */
export var Trigger = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var onClick = props.onClick,
    miniMode = props.miniMode,
    tooltipContent = props.tooltipContent,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$ariaAttributes = props.ariaAttributes,
    ariaAttributes = _props$ariaAttributes === void 0 ? {} : _props$ariaAttributes;
  var handleMouseDown = function handleMouseDown(e, analyticsEvent) {
    if (onClick && !disabled) {
      onClick(e, analyticsEvent);
    }
  };
  return jsx(Tooltip, {
    testId: RENDER_TOOLTIP_TRIGGER_TESTID,
    content: tooltipContent
  }, jsx(Button, _extends({
    testId: RENDER_TRIGGER_BUTTON_TESTID,
    css: styles.triggerStyle({
      miniMode: miniMode,
      disabled: disabled
    }),
    appearance: "subtle",
    onClick: handleMouseDown,
    "aria-disabled": disabled,
    iconBefore: jsx(EmojiAddIcon, {
      size: "small",
      label: "Add reaction"
    }),
    spacing: "none",
    ref: ref
  }, ariaAttributes)));
});